import React from 'react';
import { Popover } from '@mui/material';
import NotificationInboxContent from './NotificationInboxContent';

const NotificationPopup = ({ anchorEl, open, onClose }) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        'aria-label': 'Notifications',
        sx: {
          width: '424px',
          height: '616px',
          borderRadius: '12px',
          backgroundColor: '#FFF',
          border: '1px solid #D5DCE1',
          filter: 'drop-shadow(0px 15px 20px rgba(6, 21, 34, 0.05))',
          marginTop: '10px',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: 'none',
        },
      }}
    >
      <NotificationInboxContent open={open} onNavigateAway={onClose} />
    </Popover>
  );
};

export default NotificationPopup;
